module.exports = __webpack_public_path__ + "static/media/dans1.d4f841b1.jpg";